import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import HowItWorksSection from "./components/HowItWorksSection";
import ProductsSection from "./components/ProductsSection";
import LocationsSection from "./components/LocationsSection";
import FAQSection from "./components/FAQSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";

// 🟢 AOS imports
import AOS from "aos";
import "aos/dist/aos.css";

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <HowItWorksSection />
        <ProductsSection />
        <LocationsSection />
        <FAQSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  // 🟢 Initialise AOS once
  useEffect(() => {
    AOS.init({
      duration: 800,   // animation length in ms
      easing: "ease-out",
      once: true,      // only animate on first scroll
      offset: 40,      // trigger a bit before element is fully in view
    });
  }, []);

  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
